/**
 * @generated SignedSource<<a68ac5da86177e8f610996b8c3855675>>
 * @relayHash 66442618513dce4da3b12ba86290a6dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 323ec816519919cb7056f6bb58318c32991a0df7e8ad67c74b3e16751bb9f805

import type { ConcreteRequest } from 'relay-runtime';
export type TeamTypeState = "ACTIVE" | "DELETE_IN_PROGRESS" | "%future added value";
export type TeamTypeScopeSelectQuery$variables = {
  scopeId: string;
};
export type TeamTypeScopeSelectQuery$data = {
  readonly team: {
    readonly typesWithinScope: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly state: TeamTypeState | null;
          readonly verified: boolean | null;
        } | null;
      }> | null;
    } | null;
  } | null;
};
export type TeamTypeScopeSelectQuery = {
  response: TeamTypeScopeSelectQuery$data;
  variables: TeamTypeScopeSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeId"
  }
],
v1 = [
  {
    "concreteType": "TeamQuery",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 50
          },
          {
            "kind": "Variable",
            "name": "scopeId",
            "variableName": "scopeId"
          }
        ],
        "concreteType": "TeamTypeConnection",
        "kind": "LinkedField",
        "name": "typesWithinScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "verified"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TeamTypeScopeSelectQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamTypeScopeSelectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "323ec816519919cb7056f6bb58318c32991a0df7e8ad67c74b3e16751bb9f805",
    "metadata": {},
    "name": "TeamTypeScopeSelectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b84cc2d86e2675fbf8d3e09facc4794b";

export default node;
